<!-- eslint-disable -->
<template>
  <v-card height="100%">
    <v-card-text>
      <v-row>
        <v-col cols="12" md="4">
          <v-btn
            small
            color="info"
            class="mt-5 ml-3"
            :disabled="loader"
            @click="getAll"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn
            small
            color="success"
            class="mt-5 ml-3"
            :disabled="loader"
            @click="nuevo"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="4" offset-xl="4">
          <v-container>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Busqueda"
              single-line
              hide-details
            />
          </v-container>
        </v-col>
      </v-row>
      <v-data-table
        dense
        :items-per-page="perPage"
        :headers="headers"
        :items="items"
        :item-class="row_classes"
        class="elevation-1"
        :search.sync="search"
        mobile-breakpoint="0"
      >
        <template v-slot:[`item.pago_kilo`]="{ item }">
          {{ item.pago_kilo | moneda }}
        </template>
        <template v-slot:[`item.pago_dia`]="{ item }">
          {{ item.pago_dia | moneda }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <template v-if="item.deleted_at">
            <v-btn
              icon
              color="success"
              @click="restaurar(item)"
              :disabled="loader"
            >
              <v-icon>mdi-delete-restore</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              icon
              color="success"
              @click="editar(item)"
              :disabled="loader"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon color="orange" @click="historial(item)" :disabled="loader">
              <v-icon>mdi-history</v-icon>
            </v-btn>
            <v-btn
              icon
              color="error"
              @click="eliminar(item)"
              :disabled="loader"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Comisionistas",
  data: () => ({
    headers: [
      { text: "Nombre", value: "nombre" },
      { text: "Teléfono", value: "telefono" },
      { text: "Correo Electrónico", value: "email" },
      { text: "Acciones", value: "actions", align: "end" }
    ],
    search: undefined,
    perPage: 15
  }),
  computed: {
    ...mapState({
      items: state => state.Comisionistas.collection,
      loader: state => state.Comisionistas.loader
    })
  },
  mounted() {
    if (!this.items) this.getAll();
  },
  methods: {
    ...mapActions("Comisionistas", [
      "getAll",
      "nuevo",
      "editar",
      "deshabilitar",
      "habilitar",
      "historial"
    ]),
    eliminar(item) {
      let pregunta = `¿Deshabilitar al comisionista ${item.nombre}?`;
      window
        .swal({
          title: pregunta,
          icon: "warning",
          buttons: ["Cancelar", "Confirmar"],
          dangerMode: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.deshabilitar(item.id);
          }
        });
    },
    restaurar(item) {
      let pregunta = `¿Habilitar al comisionista ${item.nombre}?`;
      window
        .swal({
          title: pregunta,
          icon: "warning",
          buttons: ["Cancelar", "Confirmar"],
          dangerMode: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.habilitar(item.id);
          }
        });
    }
  }
};
</script>
